import { partyApi, partyEventSchema } from '@shared/api';
import { openRoomSocket } from '@shared/lib/room-socket';
import { createActionId } from '@shared/lib/id/action-id';
import { getViewerIdentity } from '@shared/lib/auth/viewer-identity';
import { PartyRoomStore } from './party-room-store';

const room = new PartyRoomStore(
  {
    ...partyApi,
    actionId: createActionId,
    open: (code, handlers) =>
      openRoomSocket('/secured/party/ws', code, (value) => partyEventSchema.safeParse(value), handlers),
  },
  () => getViewerIdentity()?.login,
);
export const getPartyRoom = () => room;
